import Expertise from "../components/Experties";
import Hero from "../components/Hero";
import InhouseFacilities from "../components/InHouseFacilities";
import NewPlant from "../components/NewPlant";
import Partners from "../components/Partners";
import Production from "../components/Production";
import Seperator from "../components/Seperator";

export default function Home() {
    return (<>
        <Hero />
        <Production/>
        <Expertise/>
        <InhouseFacilities/>
        <NewPlant/>
        <Partners />
        <Seperator/>
    </>
    );
}